import type { RoomSettings } from "@hitster/shared";

interface Props {
  settings: Pick<RoomSettings, "hintsEnabled" | "maxHintsPerPlayer">;
  onChange: (patch: Partial<RoomSettings>) => void;
}

export function HintsOption({ settings, onChange }: Props) {
  const enabled = !!settings.hintsEnabled;
  const maxHints = settings.maxHintsPerPlayer ?? 3;

  return (
    <fieldset className="space-y-2">
      <label className="flex items-center gap-2">
        <input
          type="checkbox"
          checked={enabled}
          onChange={(e) => onChange({ hintsEnabled: e.target.checked })}
        />
        <span>Indices (décennie de la chanson)</span>
      </label>
      {enabled && (
        <label className="block pl-6">
          <span className="text-sm text-violet-300">Indices max par joueur</span>
          <input
            type="number"
            className="cw-input mt-1 w-24"
            min={1}
            max={10}
            value={maxHints}
            onChange={(e) =>
              onChange({ maxHintsPerPlayer: Math.min(10, Math.max(1, Number(e.target.value) || 1)) })
            }
          />
        </label>
      )}
    </fieldset>
  );
}
